export default __webpack_public_path__ + "static/media/left-quote.86d01cb1.svg";